import React from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Box,
  Button,
  Image,
  Stack,
  Text,
  HStack,
  IconButton,
  Divider,
} from "@chakra-ui/react";
import { useCart } from "../context/CartContext";
import { FiTrash2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const CartDrawer = React.forwardRef(({ isOpen, onClose }, ref) => {
  const { cart, increaseQuantity, decreaseQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();

  const getTotal = () =>
    cart.reduce((acc, item) => acc + (item.price || 0) * item.quantity, 0);

  const handleCheckout = () => {
    onClose();
    navigate("/checkout");
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} finalFocusRef={ref} size="sm">
      <DrawerOverlay />
      <DrawerContent bg="white" borderLeftRadius="2xl" boxShadow="2xl">
        <DrawerCloseButton mt={2} />
        <DrawerHeader borderBottomWidth="1px" fontWeight="bold" fontSize="2xl" color="green.600">
          Your Cart
        </DrawerHeader>
        <DrawerBody px={4} py={6}>
          {cart.length === 0 ? (
            <Text color="gray.500" fontSize="lg" textAlign="center" mt={10}>
              No items in cart.
            </Text>
          ) : (
            <Stack spacing={6}>
              {cart.map((item) => (
                <Box key={item._id} borderWidth="1px" borderRadius="lg" p={3} boxShadow="md" bg="gray.50">
                  <HStack spacing={4} align="flex-start">
                    <Image
                      src={item.image || "/placeholder.png"}
                      alt={item.name}
                      boxSize="60px"
                      borderRadius="md"
                      objectFit="cover"
                      bg="white"
                    />
                    <Box flex="1">
                      <Text fontWeight="bold" fontSize="md" mb={1}>{item.name}</Text>
                      <Text color="green.700" fontWeight="semibold" fontSize="sm">
                        ₦{item.price?.toLocaleString()} x {item.quantity}
                      </Text>
                      <HStack mt={2} spacing={1}>
                        <Button size="xs" onClick={() => decreaseQuantity(item._id)} variant="outline" colorScheme="green">-</Button>
                        <Text fontWeight="bold" fontSize="sm">{item.quantity}</Text>
                        <Button size="xs" onClick={() => increaseQuantity(item._id)} variant="outline" colorScheme="green">+</Button>
                        <IconButton
                          icon={<FiTrash2 />}
                          size="xs"
                          colorScheme="red"
                          variant="ghost"
                          aria-label="Remove"
                          onClick={() => removeFromCart(item._id)}
                        />
                      </HStack>
                    </Box>
                  </HStack>
                </Box>
              ))}
            </Stack>
          )}
        </DrawerBody>
        <Divider />
        <DrawerFooter flexDirection="column" alignItems="stretch" bg="gray.50" borderBottomRadius="2xl">
          <Box w="100%" mb={3}>
            <Text fontWeight="bold" fontSize="lg" color="gray.700">
              Total: ₦{getTotal().toLocaleString()}
            </Text>
          </Box>
          <Button
            colorScheme="green"
            size="lg"
            w="100%"
            borderRadius="xl"
            fontWeight="bold"
            isDisabled={cart.length === 0}
            onClick={handleCheckout}
            boxShadow="md"
            _hover={{ bg: "green.600", color: "white" }}
          >
            Proceed to Checkout
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});

export default CartDrawer;
